import { Splide } from "@splidejs/splide";
// import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { windowWidth } from "./utils";
import { Popup } from "./popup";

const sliders = {
  init() {
    // this.resetSlider();
    this.setProdSliders();
    this.heroSlider();
    this.setLogoSlider();
    this.setProdThumbnailsSlider();
  },

  noSlider() {
    const noSlider = document.querySelectorAll(
      ".jsNoSlider"
    ) as NodeListOf<HTMLElement>;

    noSlider.forEach((item) => {
      this.removeSlider(item);
    });
  },
  removeSlider(item: HTMLElement) {
    const items = item.querySelectorAll(
      ".splide__slide"
    ) as NodeListOf<HTMLElement>;
    item.classList.remove("splide");
    item.classList.remove("jsCatSlider");
    item.classList.remove("jsProdSlider");
    item.firstElementChild?.classList.remove("splide__track");
    const list = item.firstElementChild?.firstElementChild;
    list?.classList.remove("splide__list");
    list?.classList.add("splide__grid");

    if (items) {
      Array.from(items).forEach((el) => {
        const item = el as HTMLElement;
        item.classList.remove("splide__slide");
      });
    }
  },
  resetSlider() {
    window.addEventListener("reset", () => {});
  },
  heroSlider() {
    const sliders = document.querySelectorAll(
      ".jsHeroSlider"
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: "loop",
        perPage: 1,
        pagination: true,
        arrows: false,
        autoplay: true,
        speed: 800,
      }).mount();
    });
  },
  setLogoSlider() {
    const slider = document.getElementById("logoSlider") as
      | HTMLElement
      | undefined;
    if (slider) {
      const main = new Splide(slider, {
        pagination: false,
        arrows: false,
        type: "loop",
        gap: "70px",
        perPage: 8,
        perMove: 1,
        breakpoints: {
          800: {
            perPage: 4,
            padding: { right: "30%" },
          },
          500: {
            perPage: 2,
            padding: { right: "30%" },
          },
        },
      });
      main.mount();
    }
  },
  setProdSliders() {
    const porductSliders = document.querySelectorAll(
      ".jsProdSlider"
    ) as NodeListOf<HTMLElement>;

    porductSliders.forEach((el) => {
      if (windowWidth < 1200) {
        new Splide(el, {
          speed: 1200,
          type: "loop",
          gap: "5px",
          pagination: false,
          padding: { right: "30%" },
          perPage: 2,
          perMove: 1,
          breakpoints: {
            500: {
              perPage: 1,
            },
          },
        }).mount();
      } else {
        this.removeSlider(el);
      }
    });
  },
 setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as
      | HTMLElement
      | undefined;
    const thumbnails = document.getElementById("thumbnails") as
      | HTMLElement
      | undefined;
    const mainImagePopup =  document.getElementById("mainImagePopup") as
    | HTMLElement
    | undefined;
    if (porductMainImages && thumbnails && mainImagePopup) {
      const options = {
        type: "fade",
        rewind: true,
        pagination: true,
        arrows: true,
      }
      const main = new Splide(porductMainImages, options);   
      main.on( 'mounted',  ()=> {     
        const popup = new Popup("#imagePopup", ".jsOpenGallery", ".jsClose");
        popup.init(); 
      } );
    
      const imagePopup = new Splide(mainImagePopup, {...options, pagination:false});
      if (windowWidth > 768) {
        const thumbnailsNav = new Splide(thumbnails, {
          direction: "ltr",
          isNavigation: true,
          pagination: false,
          heightRatio: 6,
          perPage: 6,
          arrows: false,        
          fixedHeight: "70px",
          gap: "20px",
          breakpoints: {
            767: {
              direction: "ltr",
              perPage: 5,
              heightRatio: 5,       
              fixedHeight: "100px",
            },
       
          },
        });

        main.sync(thumbnailsNav);
        main.mount();
        thumbnailsNav.mount();
      } else {
        main.mount();
      }
      imagePopup.mount()

    }
  },
};

export default sliders;
